<div #container
     (wheel)="debouncedOnScroll()"
     (window:resize)="debouncedOnResize()"
     [class.scrolled]="applicationStateService.currentViewMode.slug === 'scroll'"
     [class.sidebar-active]="!applicationStateService.isSidebarHidden"
     [class.zoomed]="applicationStateService.isZoomed"
     [ngStyle]="{
         'padding-top.px': containerPadding.top,
         'padding-right.px': containerPadding.right,
         'padding-bottom.px': containerPadding.bottom,
         'padding-left.px': containerPadding.left
     }"
     class="pages-container">


    <div [class.scrolled]="applicationStateService.currentViewMode.slug === 'scroll'"
         class="pages-position-container">

        @if (applicationStateService.currentViewMode.slug === 'scroll' && currentScrollTopValue > 10) {
            <div
                [ngStyle]="{
                    'width.px': singlePageWidth,
                    'transform': 'translateX(' + (containerTranslateX) + 'px)'
                }"
                id="scrollShadowTop"
                tabindex="-1"
            >
            </div>
        }

        <div bookviewerAccessbilityComponent
             #pagesContainer
             [badgeInstruction]="'Drücke Enter um zum Seiteninhalt zu gelangen'"
             (pan)="onPan($event)"
             (panstart)="onPanStart($event)"
             (tap)="onDoubleTab($event)"
             [class.blurred]="isModalOpen()"
             [class.ie]="isIE"
             [class.scrolled]="applicationStateService.currentViewMode.slug === 'scroll'"
             [class.shadow]="!applicationStateService.isZoomed && applicationStateService.currentViewMode.slug !== 'scroll'"
             [ngStyle]="{
                'height.px': containerHeight,
                'width.px': containerWidth + (applicationStateService.currentViewMode.slug === 'scroll' ? 100 : 0),
                'transform': 'translate(' + containerTranslateX + 'px, ' + (containerTranslateY * isDefaultMode) + 'px)'
             }"
             class="pages">

            @if (applicationStateService.currentViewMode.slug !== 'scroll') {
                @for (page of currentPages; track page.id) {
                    <app-page [imageHeight]="singlePageHeight" [imageWidth]="singlePageWidth"
                              [isFirstPage]="page.index === 0"
                              [page]="page"
                              [pagesContainer]="$container"></app-page>
                }
            }


            @if (applicationStateService.currentViewMode.slug === 'scroll') {
                <app-scroll-pages
                        [container]="$container"
                        [imageHeight]="singlePageHeight"
                        [imageWidth]="singlePageWidth"></app-scroll-pages>
            }


        </div>
        @if (applicationStateService.currentViewMode.slug === 'scroll') {
            <div [ngStyle]="{
                'bottom.px': (windowWidth < env.mobileBreakPoint) * -5,
                'width.px': singlePageWidth,
                'transform': 'translateX(' + (containerTranslateX) + 'px)'
             }"
                 id="scrollShadowBottom">
            </div>
        }


        @if (applicationStateService.currentViewMode.slug !== 'scroll' || windowWidth <= (env.mobileBreakPoint + 1)) {
            <div bookviewerAccessbilityComponent
                 [badgeInstruction]="'Drücke Enter um in die Seiten- und Kapitel-Navigation zu gelangen'"
                    [ngStyle]="{ 'width.px': footerWidth }" class="bookviewer-footer-container">
                @if (applicationStateService.currentViewMode.showFooter || windowWidth <= (env.mobileBreakPoint + 1)) {
                    <div id="footerWrapper">
                        <app-footer #footer
                        ></app-footer>
                    </div>
                }
            </div>
        }
    </div>
    <div tabindex="-1">
        <app-modal-container></app-modal-container>
    </div>

</div>

